export default __webpack_public_path__ + "static/media/4-2.5cc3f2e5.jpg";